import { useEffect } from 'react';
import Animated, { Easing, useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated';
import { brand } from 'src/theme/colors';

const COLORS = [
  brand.main.orange,
  brand.main.hibiscus,
  brand.main.mustard,
  brand.main.water,
  brand.main.orange,
  brand.main.water,
];

export const ConfettiPiece = ({
  centerX = 0,
  centerY = 0,
  duration = 0,
  triggerExplosion = false,
}: {
  centerX: number;
  centerY: number;
  duration: number;
  triggerExplosion: boolean;
}) => {
  const xSV = useSharedValue(centerX);
  const ySV = useSharedValue(centerY);
  const scaleSV = useSharedValue(1);
  const opacitySV = useSharedValue(1);

  const explosionRadius = Math.random() * 300;

  useEffect(() => {
    if (triggerExplosion) {
      const angle = Math.random() * 2 * Math.PI;
      const distance = Math.random() * explosionRadius;
      const targetX = centerX + Math.cos(angle) * distance;
      const targetY = centerY + Math.sin(angle) * distance;
      xSV.value = withTiming(targetX, { duration, easing: Easing.ease });
      ySV.value = withTiming(targetY, { duration, easing: Easing.ease });
      scaleSV.value = withTiming(0, { duration: duration, easing: Easing.ease });
      opacitySV.value = withTiming(0, { duration: duration, easing: Easing.ease });
    }
  }, [triggerExplosion]);

  const style = useAnimatedStyle(() => ({
    position: 'absolute',
    left: xSV.value,
    top: ySV.value,
    transform: [{ scale: scaleSV.value }],
    opacity: opacitySV.value,
  }));

  const size = 6 + Math.random() * 6;
  const bg = COLORS[Math.floor(Math.random() * COLORS.length)];

  return (
    <Animated.View
      style={[
        style,
        {
          width: size,
          height: size,
          backgroundColor: bg,
        },
      ]}
    />
  );
};
